<template>
  <div class="page-content -column -column-two">
    <h3 class="section-title -mb">Event Tracking</h3>

    <label>Google Anayltics Tracking ID</label>
    <input v-model="resource.ga_code" type="text" />
    <span v-if="errors.ga_code" class="alert -inline -danger">
      {{ [...errors.ga_code].join(', ') }}
    </span>

    <action-button class="-mt" :text="'Update Settings'" :state="state" @pressed="submit"></action-button>
  </div>
</template>

<script>
import actionButton from "@/components/actionButton";
import settingsBase from "@/components/settings/base.vue";

export default {
  components: { actionButton },
  extends: settingsBase,

  data() {
    return {
      fields: ["ga_code"]
    };
  }
};
</script>
